module.exports = "/wp-content/themes/FFFA/dist/images/ball.png?275d2fe000508e40c9f79e988664b7a2";